module.exports = __webpack_public_path__ + "media/images/trofeu-bc150d6d507d23b36af0d89f4739656c.svg";